import axiosInstance from '../services/axios'
import { AxiosResponse } from 'axios'
import localStorageService from '../services/local.storage'

class AvatarService {

    constructor(private apiVersion: string = 'v1') {
    }

    public save(userId: string, avatar: any, type: string) {
        const data = new FormData()
        data.append('avatar', avatar)
        return axiosInstance.put(`${this.apiVersion}/${type}/${userId}/avatar`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public get(userId: string, type: string, saveInStorage?: boolean): Promise<any> {
        return axiosInstance.get(`${this.apiVersion}/${type}/${userId}/avatar`, { responseType: 'blob' })
            .then((response: AxiosResponse) => {
                if (saveInStorage) {
                    const reader = new FileReader()
                    reader.readAsDataURL(response.data)
                    reader.onloadend = () => {
                        const base64data = reader.result
                        if (base64data && typeof base64data === 'string') {
                            localStorageService.setItem('avatar', base64data)
                        }
                    }
                }
                return URL.createObjectURL(response.data)
            })
    }

    public remove(userId: string, type: string) {
        return axiosInstance.delete(`${this.apiVersion}/${type}/${userId}/avatar`)
    }

}
const avatarService = new AvatarService()

export default avatarService
